import { Module } from 'vuex';
import IServicesState from './types/IServicesState';
import IRootState from '@/store/types/IRootState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const services: Module<IServicesState, IRootState> = {
  namespaced: true,
  state: {
    meta: {
      title: '',
      description: '',
    },
    header: {
      title: '',
      description: '',
      image: '',
    },
    services: [],
  },
  actions,
  getters,
  mutations,
};

export default services;
